import * as UI              from '../ui';
import * as User            from '../user';
import { useTwilioContext } from './wait_for_twilio';
import ms                   from 'ms';
import React                from 'react';
import rollbar              from '../rollbar';
import store                from '../store';
import xhr                  from 'xhr';


export default function useConversation(uniqueName, otherParticipants = []) {
  const [ forceUpdate, setForceUpdate ]   = React.useState(true);
  const [ conversation, setConversation ] = React.useState(null);
  const { client }                        = useTwilioContext();

  React.useEffect(function() {
    async function fetchConversation() {
      try {
        store.dispatch(UI.progressStart());
        const channel = await client.getChannelByUniqueName(uniqueName);
        setConversation(channel);
      } catch (error) {
        if (error.status === 404) {
          const participantsIDs = otherParticipants.map(participant => participant.id);
          const response        = await createConversation(participantsIDs);
          if (response.uniqueName === uniqueName)
            await fetchConversation();
          else
            rollbar.error(`Team Chat Error: creating room for ${participantsIDs}`);
        } else
          throw error;
      } finally {
        store.dispatch(UI.progressEnd());
      }
    }

    fetchConversation();
  }, [ client, otherParticipants, uniqueName ]);

  React.useEffect(function() {
    function onConversationChange({ channel }) {
      setConversation(channel);
      setForceUpdate(!forceUpdate);
    }

    if (conversation)
      conversation.on('updated', onConversationChange);

    return function() {
      if (conversation)
        conversation.removeListener('updated', onConversationChange);
    };
  }, [ conversation, forceUpdate ]);

  return conversation;
}

async function createConversation(participants) {
  const { jwtToken } = User.getAccessToken(store.getState());

  return new Promise(function(resolve, reject) {
    xhr({
      url:     `${API_URL}/team_chat/room`,
      method:  'POST',
      timeout: ms('5s'),
      json:    true,
      headers: {
        Authorization: `Bearer ${jwtToken}`
      },
      body: {
        participants
      }
    }, function(error, response, body) {
      if (error)
        reject(error);

      resolve(body);
    });
  });
}
